// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"7d1f59cd","87":"7d1f59cd","369":"7d1f59cd","444":"7d1f59cd","632":"7d1f59cd"}[chunkId] + ".chunk.css";
};